import type { PwaCalendarBooking } from '@/calendar/pwaCalendarUtils';

export type BookingSource = Pick<
  PwaCalendarBooking,
  'bookingOrigin' | 'otaChannel' | 'conversationChannel'
>;

export function bookingSourceLabel(source: BookingSource): string {
  if (source.bookingOrigin === 'ota') {
    const labels: Record<string, string> = {
      airbnb: 'Airbnb',
      booking: 'Booking.com',
      vrbo: 'Vrbo',
      expedia: 'Expedia',
      other: 'OTA',
    };
    return labels[source.otaChannel ?? 'other'] ?? 'OTA';
  }
  return 'Interactive Talker';
}
